export default __webpack_public_path__ + "static/media/amex_card.d5cdcaee.svg";